import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/store/index';
import { useMemo, useState, useEffect } from 'react';
import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import { nocStatus } from '@/pages/timeline/sections/timeline/timelineSections/noc/constants'
import { keyForCodeForSection, sectionLockStatus } from '@/pages/timeline/sections/timeline/timelineSections/constants'

import GreyTick from "@/assets/icons/greyTick.png";
import NocIndexView from './view'
import EmptyModal from '@/components/common/emptyModal/emptyModal';
import ImageHandler from '@/components/common/imageHandler/imageHandler';
import { updateUserProfileApiCall, uploadImage } from '@/services/api';
import { dataURLtoBlob } from '@/utils';
import { FOLDER_PATHS, FILE_NAME } from '@/constants/imageFolderPaths';
import { idVerificationProofStatus } from '@/pages/profile/sections/idVerification/constants';
import { setTimeline } from '@/store/slices/timeline/timelineSlice';

export default function NocIndex(props: any) {
    const { common } = useLocalTranslation();
    const dispatch = useDispatch();
    const timelineDetails = useSelector((state: RootState) => state.timelineReducer.timeline);
    const timelineAccordionStatus = useSelector((state: RootState) => state.timelineAccordionStatusReducer.timelineAccordionStatus);
    const [isSectionLocked, setIsSectionLocked] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [openFilePopup, setOpenFilePopup] = useState(false)
    const [isUploading, setIsUploading] = useState(false)
    const docLink = "https://docs.google.com/document/d/1C6jXp0XeZxsbUmqZ15ZADujlCPiy09UBvRo2YLl26As"
    const payInfoPopupContent = {
        title: "",
        content: `<p><a target="_blank" href='${docLink}'>${common.statusText.clickHere}</a> ${common.statusText.s4}</p>`
    }


    useEffect(() => {
        handleIsSectionLocked()
    }, [timelineAccordionStatus])

    const handleIsSectionLocked = () => {
        if (timelineAccordionStatus[keyForCodeForSection.submit] === sectionLockStatus.locked) {
            setIsSectionLocked(true)
        }
    }

    const handleNocUplaod = (action: string) => {
        if (action !== "action" || isUploading) return

        setOpenFilePopup(true)
        setTimeout(() => {
            setOpenFilePopup(false)
        }, 100)
    }

    const handleImageSelected = async (imageDataURI: string) => {
        if (!imageDataURI) return

        try {
            setIsUploading(true)

            const imgBlob = dataURLtoBlob(imageDataURI)
            if (!imgBlob.status || !imgBlob.blob) {
                console.log('handleNocUplaod', 'issue in converting base64 to blob')
                return
            }

            const response = await uploadImage(
                imgBlob.blob,
                FOLDER_PATHS.NOC_DOCUMENTS,
                FILE_NAME.NOC_DOCUMENT
            )

            if (response?.status && response?.data?.cloudFrontUrl) {
                const cloudFrontUrl = response.data.cloudFrontUrl
                const nocSubmittedAt = new Date().toISOString()

                const payload = {
                    nocDocumentStatus: idVerificationProofStatus.inProgress,
                    nocDocument: cloudFrontUrl,
                    nocSubmittedAt,
                }

                const updateRes = await updateUserProfileApiCall(payload)

                if (updateRes?.status) {
                    dispatch(setTimeline({
                        ...timelineDetails,
                        ...payload,
                        nocStatus: nocStatus.submitted,
                    }))
                } else {
                    console.log('handleNocUplaod', 'profile update failed', updateRes)
                }
            } else {
                console.log('handleNocUplaod', 'upload failed', response)
            }
        } catch (error) {
            console.log('handleNocUplaod error', error)
        } finally {
            setIsUploading(false)
        }
    }

    const buttonUI = useMemo(() => {
        let isDisable = false
        let btnText: string = common.statusText.uploadBtn
        let cursorStyle = "pointer"
        let btnAction = "action"
        let showGreyTick = false
        if (timelineDetails.nocStatus === nocStatus.locked) {
            isDisable = true
            cursorStyle = "not-allowed"
            btnAction = "noAction"
        } else if (timelineDetails.nocStatus === nocStatus.submitted) {
            btnText = common.statusText.submittedText
            cursorStyle = "default"
            btnAction = "noAction"
            showGreyTick = true
        } else if (timelineDetails.nocStatus === nocStatus.verified) {
            btnText = common.status.completed
            cursorStyle = "default"
            btnAction = "noAction"
            showGreyTick = true
        }

        return (
            <button
                disabled={isDisable}
                style={{
                    cursor: cursorStyle,
                    lineHeight: "16px",
                    marginLeft: "10px"
                }}
                onClick={() => handleNocUplaod(btnAction)}
                className='handleNocUplaodBtn flex items-center text-[12px] my500px:text-[14px] rounded-[5px] px-[6px] py-[6px]'>
                {showGreyTick &&
                    <img className='w-[15px] mr-[4px]' src={GreyTick} alt='greyTick' />
                }
                {btnText}
            </button>

        )
    }, [timelineDetails]);


    const handleOpenModal = () => {
        setShowModal(true)
    };
    const handleCloseModal = (status: string) => {
        setShowModal(false)
    }



    return (
        <>
            <NocIndexView
                timelineDetails={timelineDetails}
                buttonUI={buttonUI}
                isSectionLocked={isSectionLocked}
                handleOpenModal={handleOpenModal}
            />

            <EmptyModal
                show={showModal}
                handleClose={handleCloseModal}
                popupInfo={payInfoPopupContent}
            />

            <ImageHandler
                openFilePopup={openFilePopup}
                imageSelected={handleImageSelected}
            />
        </>
    );
};

